import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../Environment/environment';

@Injectable({
  providedIn: 'root'
})
export class RequestManagementService {

  constructor(private http: HttpClient) { }

  //---------- Get Request List ------------------//

  getRequestList(api: string, cityId?: number, zoneId?: number) {
    let params = '';

    if (cityId) {
      params += `?CityId=${cityId}`;
    }

    if (zoneId) {
      params += (params ? '&' : '?') + `ZoneId=${zoneId}`;
    }

    return this.http.get(environment.baseUrl + api + params);
  }

}
